import { type RefObject, useLayoutEffect, useRef, useState } from "react";

/** `null` until first measured (forever in jsdom): treat it as "no constraint known", not zero. */
export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(): [
  RefObject<T | null>,
  number | null,
] => {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setWidth(el.getBoundingClientRect().width);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};
